module.exports = __webpack_public_path__ + "static/media/buffet2.084d73fc.jpg";